var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadCloudFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "rgba(255,255,255,1)"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 20.981a6.5 6.5 0 01-2.936-12 8.001 8.001 0 0115.872 0 6.5 6.5 0 01-2.936 12V21H7v-.019zM13 12V8h-2v4H8l4 5 4-5h-3z"
  })));
}
export default __webpack_public_path__ + "static/svg/download-cloud-fill.svg";
export { SvgDownloadCloudFill as ReactComponent };